export const diorEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT || '/api';
